import React from 'react'
import { useWorkspace } from 'zens-store'
import { StyleSheet, ViewProps } from 'react-native'

import { FloorField } from '../floor'

const styles = StyleSheet.create({
  floor: {
    marginLeft: 0,
  },
})

interface Props extends ViewProps {
  companyId: number
  workspaceId: number
}
const ProductFloor = (props: Props) => {
  const { companyId, workspaceId, style, ...otherProps } = props
  const workspace = useWorkspace({ companyId, workspaceId })

  return (
    <FloorField
      companyId={companyId}
      value={workspace.data?.floorId || 0}
      style={[styles.floor, style]}
      {...otherProps}
    />
  )
}

export default ProductFloor
